/* eslint-disable no-underscore-dangle */
const getLoadId = load => {
  if (!load) {
    return '';
  }
  if (load.id !== undefined && load.id !== null) {
    return String(load.id);
  }
  if (load._id !== undefined && load._id !== null) {
    return String(load._id);
  }
  return '';
};

const findLoadById = (loadId, lists) => {
  if (loadId === undefined || loadId === null) {
    return null;
  }

  const targetId = String(loadId);

  return lists.reduce((found, list) => {
    if (found || !Array.isArray(list)) {
      return found;
    }
    return list.find(load => getLoadId(load) === targetId) || null;
  }, null);
};

export default findLoadById;
